import React, { useEffect, useState, useRef } from "react";

import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';

import { auth, firebase } from "../../Firebase/config";

import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import axios from "axios";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import "../Messages.css";

export default function Phonelessstudents({
  currentclass,
  activename,
  setSelectedclass,
  activeid2,
  activename2,
  selectedclass,
  currentstudent,
  setCurrentstudent,
  studentidd,
  parentlanguagecode,
  id2,
  temparray,
  databaseactivename,
  activeid,
  id,
  role,
  astheycome,
  setAstheycome
}) {

  const [lasttwomonths, setlasttwomonths] = useState([]);

  const [searchingstate, setSearchingstate] = useState(false);
  const [aallpasses, setAallpasses] = useState();

  const [filteredstates, setFilteredstates] = useState([]);

  const [activpasses, setActivpasses] = useState([]);
  const [update, setUpdate] = useState();

  const [changehasbeenmade, setChangehasbeenmade] = useState();
  const [endtime, setEndtime] = useState();
  const [begintime, setBegintime] = useState();

  const [revise, setRevise] = useState();

  const [passesbetween, setPassesbetween] = useState();

  const [currentclass2, setCurrentclass2] = useState();
  const [activeid22, setActiveid2] = useState();

  const [website, setWebsite] = useState();
  const [whatparentssee, setWhatpareentseee] = useState();
  const [thispage, setThispage] = useState();

  const [pdfFileUrl, setPdfFileUrl] = useState(null); // for Viewer
  const [pdfText, setPdfText] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const navigate = useNavigate();



  const selectHandler = (value, i) => {

    if (value && activeid2 != value.id) {

      setSelectedclass(value);
    } else {
      setSelectedclass("");
    }

  };

  useEffect(() => {
    setThispage(window.location.href)


  }, []);


  // Utility: extract info from a PDF page string
function extractInfoFromPdfPage(pageText) {
  // 1. parentemail: all emails

  const filterStudentData = (array, dataType) => {
      return array.filter((item) => {
        const itemEscaped = item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        if (dataType === 'email') {
          // Look for "student email" key near this email value
          const studentEmailPattern = new RegExp(`student\\s+email[^@]*${itemEscaped}`, 'i');
          if (studentEmailPattern.test(pageText)) {
            console.log(`Filtering out student email: ${item}`);
            return false;
          }
        } else if (dataType === 'phone') {
          // Look for "student phone" or "student number" key near this phone value
          const studentPhonePattern = new RegExp(`student\\s+(?:phone|number)[^0-9]*${itemEscaped.replace(/\D/g, '')}`, 'i');
          if (studentPhonePattern.test(pageText)) {
            console.log(`Filtering out student phone: ${item}`);
            return false;
          }
        }
        return true;
      });
    };




   let parentemail = Array.from(
pageText.matchAll(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}/g)
).map((m) => m[0]);
parentemail = filterStudentData(parentemail, "email");

  // 2. parentphonenumber: all 10-digit numbers (strip formatting, no leading 1)
  const phoneRaw = Array.from(pageText.matchAll(/(?:\+?1[-.\s]*)?\(?(\d{3})\)?[-.\s]*(\d{3})[-.\s]*(\d{4})/g));
  let parentphonenumber = phoneRaw.map(m => {
    let digits = `${m[1]}${m[2]}${m[3]}`;
    if (digits.length === 10) return digits;
    if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
    return "";
  }).filter(Boolean);

   parentphonenumber = filterStudentData(parentphonenumber, 'phone');

  // 3. password: after "Password" or "Student Password"
  let password = "";
  const pwMatch = pageText.match(/(?:Student\s+Password|Password)\s+([^\s]+)/i);
  if (pwMatch) password = pwMatch[1];

  // 4. gender: look for "male", "female", "m", "f" as standalone words
  let gender = "";
  const genderMatch = pageText.match(/\b(male|female|m|f)\b/i);
  if (genderMatch) {
    const g = genderMatch[1].toLowerCase();
    if (g === "male" || g === "m") gender = "he";
    if (g === "female" || g === "f") gender = "she";
  }

  // 5. passwordactual: same as password
  let passwordactual = password;

  // 6. homeroom: extract homeroom
  let homeroom = "";
  const lines = pageText.split(/[\n\r]+/);
  for (let line of lines) {
    if (/home\s*room/i.test(line)) {
      const match = line.match(/home\s*room[^a-zA-Z0-9]{0,10}([a-zA-Z0-9]{1,7})/i);
      if (match) {
        homeroom = match[1];
        break;
      }
      const matchBefore = line.match(/([a-zA-Z0-9]{1,7})[^a-zA-Z0-9]{0,10}home\s*room/i);
      if (matchBefore) {
        homeroom = matchBefore[1];
        break;
      }
    }
  }

  let dateofbirth = "";
    let dobFound = false;

    // Strategy 1: Look for "dob", "date of birth", "dateofbirth" key with date value on same line
    for (let line of lines) {
      if (/(dob|date\s+of\s+birth|dateofbirth)\s*[:=]?\s*/i.test(line)) {
        // Match MM/DD/YYYY format
        const dateMatch = line.match(/(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
        if (dateMatch) {
          dateofbirth = `${dateMatch[1]}/${dateMatch[2]}/${dateMatch[3]}`;
          dobFound = true;
          console.log(`Found DOB via key-value: ${line.trim()}`);
          break;
        }
      }
    }

    // Strategy 2: Look for standalone date patterns (MM/DD/YYYY)
    if (!dobFound) {
      const datePattern = pageText.match(/(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
      if (datePattern) {
        dateofbirth = `${datePattern[1]}/${datePattern[2]}/${datePattern[3]}`;
        dobFound = true;
        console.log(`Found DOB via date pattern: ${datePattern[0]}`);
      }
    }

    if (!dobFound) {
      console.log("DOB not found");
    }

  return { parentemail, parentphonenumber, gender, password, passwordactual, homeroom: homeroom || "", dateofbirth };
}

  // Main matching and updating function
  async function matchAndUpdateStudents(astheycome, pdfPagesArray, firebase, activeidParam) {
    console.log(`🔵 matchAndUpdateStudents START: activeid=${activeidParam}, studentCount=${astheycome.length}, pdfPages=${pdfPagesArray.length}`);
    
    let updatedCount = 0;
    let unmatchedStudents = [];
    let newStudentIds = [];
    
    for (let i = 0; i < astheycome.length; i++) {
      const student = astheycome[i];
      const first = (student.localfirstname || "").toLowerCase();
      const last = (student.locallastname || "").toLowerCase();
      const emailPrefix = (student.email || "").split("@")[0].toLowerCase();

      console.log(`📍 Processing student ${i + 1}/${astheycome.length}: ${first} ${last} (${student.email})`);

      // Find all pages with at least 2 out of 3 matches
      let candidatePages = [];
      for (let j = 0; j < pdfPagesArray.length; j++) {
        const originalText = pdfPagesArray[j].rawText || pdfPagesArray[j].parsed || pdfPagesArray[j] || "";
        const pageTextLower = originalText.toLowerCase();
        let found = [
          pageTextLower.includes(first),
          pageTextLower.includes(last),
          pageTextLower.includes(emailPrefix)
        ];
        const count = found.filter(Boolean).length;
        if (count >= 2) {
          candidatePages.push({ idx: j, pageText: originalText, found });
          console.log(`  ✓ Found match on page ${j + 1}: ${found.join(', ')}`);
        }
      }

      let info = {};
      if (candidatePages.length === 1) {
        // Only one page matches with 2 out of 3
        info = extractInfoFromPdfPage(candidatePages[0].pageText);

        console.log(`✅ Single match found for ${first} ${last}, updating Firestore with:`, info);

        // Update Firebase user document
        try {
          await updateDoc(doc(firebase, "users", student.id), {
            parentphonenumber: arrayUnion(...info.parentphonenumber),
            parentemail: arrayUnion(...info.parentemail),
            gender: info.gender,
            password: info.password,
            passwordactual: info.passwordactual,
            homeroom: info.homeroom,
            dateofbirth: info.dateofbirth
          });
          console.log(`✅ Updated student ${student.id} in Firestore with:`, info);
        } catch (err) {
          console.error(`❌ Error updating student ${student.id}:`, err);
        }

        // Update locally
        astheycome[i] = {
          ...student,
          parentphonenumber: Array.isArray(student.parentphonenumber)
            ? Array.from(new Set([...student.parentphonenumber, ...info.parentphonenumber]))
            : Array.from(new Set(info.parentphonenumber)),
          parentemail: Array.isArray(student.parentemail)
            ? Array.from(new Set([...student.parentemail, ...info.parentemail]))
            : Array.from(new Set(info.parentemail)),
          gender: info.gender,
          password: info.password,
          passwordactual: info.passwordactual,
          homeroom: info.homeroom,
          dateofbirth: info.dateofbirth
        };
        updatedCount++;
      } else if (candidatePages.length > 1) {
        // More than one page matches with 2 out of 3, check for unique email prefix
        const pagesWithEmailPrefix = candidatePages.filter(p => p.pageText.includes(emailPrefix));
        if (pagesWithEmailPrefix.length === 1) {
          info = extractInfoFromPdfPage(pagesWithEmailPrefix[0].pageText);

          console.log(`✅ Multiple matches found, but email prefix is unique for ${first} ${last}, updating Firestore with:`, info);

          try {
            await updateDoc(doc(firebase, "users", student.id), {
              parentphonenumber: arrayUnion(...info.parentphonenumber),
              parentemail: arrayUnion(...info.parentemail),
              gender: info.gender,
              password: info.password,
              passwordactual: info.passwordactual,
              homeroom: info.homeroom,
               dateofbirth: info.dateofbirth

            });
            console.log(`✅ Updated student ${student.id} in Firestore with:`, info);
          } catch (err) {
            console.error(`❌ Error updating student ${student.id}:`, err);
          }

          astheycome[i] = {
            ...student,
            parentphonenumber: Array.isArray(student.parentphonenumber)
              ? Array.from(new Set([...student.parentphonenumber, ...info.parentphonenumber]))
              : Array.from(new Set(info.parentphonenumber)),
            parentemail: Array.isArray(student.parentemail)
              ? Array.from(new Set([...student.parentemail, ...info.parentemail]))
              : Array.from(new Set(info.parentemail)),
            gender: info.gender,
            password: info.password,
            passwordactual: info.passwordactual,
            homeroom: info.homeroom,
            dateofbirth: info.dateofbirth
          };
          updatedCount++;
        } else {
          console.log(`⚠️ Ambiguous match for student ${student.id} (${first}, ${last}, ${emailPrefix}), skipping update.`);
        }
      } else {
        console.log(`ℹ️ No match for student ${student.id} (${first}, ${last}, ${emailPrefix})`);
        unmatchedStudents.push(student);
      }

      // Always push the student to the new studentIds array (using info if available)
      newStudentIds.push({
        email: student.email || "",
        firebasestudentid: student.id || "",
        firstName: student.localfirstname || "",
        lastName: student.locallastname || "",
        parentemail: info.parentemail ? info.parentemail : [],
        parentlanguagecode: student.parentlanguagecode || "en",
        languagecode: student.languagecode || "en",
        studentId: student.googleclassroomid || "",
        gender: info.gender || "",
        homeroom: info.homeroom || "",
        dateofbirth: info.dateofbirth || ""
      });
    }

    // Update the studentIds array in classesbeingtaught/activeidParam
    if (activeidParam) {
      try {
        console.log(`🔄 Updating classesbeingtaught/${activeidParam} with ${newStudentIds.length} students`);
        await updateDoc(doc(firebase, "classesbeingtaught", activeidParam), {
          studentIds: newStudentIds
        });
        console.log(`✅ studentIds updated for class ${activeidParam}`);
      } catch (err) {
        console.error(`❌ Error updating studentIds for class ${activeidParam}:`, err);
      }
    } else {
      console.warn(`⚠️ activeidParam is undefined, skipping classesbeingtaught update`);
    }

    // Update state
    setAstheycome([...astheycome]);

    console.log(`🔵 matchAndUpdateStudents END: Updated ${updatedCount} students, ${unmatchedStudents.length} unmatched`);
    return { updatedCount, unmatchedStudents, updatedStudents: astheycome };
  }

  // Usage example (call this after PDF is parsed and astheycome is available):
  // await matchAndUpdateStudents(astheycome, pdfText, firebase);

  // pdfText should be an array of page objects with .rawText property (from your handleFileChange logic).


  async function getstudentsfromgc() {
    if (typeof activeid2 != "undefined") {

      updateDoc(doc(firebase, "classesbeingtaught", activeid), {
        googleclassroomid: activeid2,
        googleclassroomname: activename2,
      }).catch((error) => {
        console.log(error); alert(error);
      })


      async function waitForLocalStorageItems(keys) {
        return new Promise((resolve) => {
          const interval = setInterval(() => {
            const allItemsPresent = keys.every((key) => localStorage.getItem(key) !== null);
            if (allItemsPresent) {
              clearInterval(interval);
              resolve();
            }
          }, 100); // Check every 100ms
        });
      }

      await waitForLocalStorageItems(["refresh_token", "access_token", "expiry_date"]);


      const refreshToken = localStorage.getItem("refresh_token");
      const accessToken = localStorage.getItem("access_token");
      const expiryDate = localStorage.getItem("expiry_date");



      const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
      const currentUrl = window.location.href;
      // Get the current URL

      const isProduction = process.env.NODE_ENV === "production";
      const baseUrl = isProduction ? "https://fastclasspass.web.app" : "http://localhost:3000";
      const redirectUrl = `${baseUrl}/role/${role}/mainmenu/id/${id}/gcstudents`;

      try {
        const stateParam = JSON.stringify({
          id: id,
          currentUrl: currentUrl,
          task: "fetchStudents",
          redirectUrl: redirectUrl,
          courseId: activeid2,
          databasecourseId: activeid,
        });
        const response = await fetch(`${API_BASE_URL}/api/login?state=${encodeURIComponent(stateParam)}`, { method: "GET" });
        const finalUrl = response.url || "";
        if (!finalUrl.startsWith(API_BASE_URL)) {
          window.location.href = `${redirectUrl}?id=${id}&dataStoredInDatabase=true`;
          return;
        }
        const data = await response.json();
        console.log("Auth URL:", data.authUrl);
        if (data.authUrl) {
          window.location.href = data.authUrl;
        } else {
          console.error("Auth URL not received from the server.");
          alert("Failed to retrieve the authentication URL.");
        }
      } catch (error) {
        console.error("Error during login:", error.message);
        alert("Failed to initiate login. Please check the console for details.");
      }
    }
  }


  function extractStudentInfo(pageText) {
    // 1. parentemail: all emails

      const filterStudentData = (array, dataType) => {
      return array.filter((item) => {
        const itemEscaped = item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        if (dataType === 'email') {
          // Look for "student email" key near this email value
          const studentEmailPattern = new RegExp(`student\\s+email[^@]*${itemEscaped}`, 'i');
          if (studentEmailPattern.test(pageText)) {
            console.log(`Filtering out student email: ${item}`);
            return false;
          }
        } else if (dataType === 'phone') {
          // Look for "student phone" or "student number" key near this phone value
          const studentPhonePattern = new RegExp(`student\\s+(?:phone|number)[^0-9]*${itemEscaped.replace(/\D/g, '')}`, 'i');
          if (studentPhonePattern.test(pageText)) {
            console.log(`Filtering out student phone: ${item}`);
            return false;
          }
        }
        return true;
      });
    };


  let parentemail = Array.from(
pageText.matchAll(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}/g)
).map((m) => m[0]);
parentemail = filterStudentData(parentemail, "email");

    // 2. parentphonenumber: all 10-digit numbers (strip formatting, no leading 1)
    const phoneRaw = Array.from(pageText.matchAll(/(?:\+?1[-.\s]*)?\(?(\d{3})\)?[-.\s]*(\d{3})[-.\s]*(\d{4})/g));
    let parentphonenumber = phoneRaw.map(m => {
      let digits = `${m[1]}${m[2]}${m[3]}`;
      if (digits.length === 10) return digits;
      if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
      return "";
    }).filter(Boolean);
    parentphonenumber = filterStudentData(parentphonenumber, 'phone');

    // 3. password: after "Password" or "Student Password" (preserve casing)
    let password = "";
    const pwMatch = pageText.match(/(?:Student\s+Password|Password)\s+([^\s]+)/i);
    if (pwMatch) password = pwMatch[1];

    // 4. gender: look for "male", "female", "m", "f" as standalone words (case-insensitive)
    let gender = "undisclosed";
    const genderMatch = pageText.match(/\b(male|female|m|f)\b/i);
    if (genderMatch) {
      const g = genderMatch[1].toLowerCase();
      if (g === "male" || g === "m") gender = "male";
      if (g === "female" || g === "f") gender = "female";
    }

    // 5. name: after "Student Name", "First Name", "Last Name"
    let name = "";
    const nameMatch = pageText.match(/(?:Student\s+Name|First\s+Name|Last\s+Name)\s+([^\s,]+)/i);
    if (nameMatch) name = nameMatch[1];
    // fallback: try "Name (Last, First MI)"
    if (!name) {
      const altNameMatch = pageText.match(/Name\s+\(Last,\s*First\s*MI\)\s+([^\s,]+)/i);
      if (altNameMatch) name = altNameMatch[1];
    }

    // 6. homeroom: ADD THIS SECTION
// 6. homeroom: improved extraction
// 6. homeroom: improved extraction
    let homeroom = "";
    const lines = pageText.split(/[\n\r]+/);

    console.log("Homeroom search - Line with 'room':", lines.filter(l => /room/i.test(l)));

    for (let line of lines) {
      if (/home\s*room/i.test(line)) {
        // Try to find value after "home room" (0-10 chars of non-alphanumeric)
        const match = line.match(/home\s*room[^a-zA-Z0-9]{0,10}([a-zA-Z0-9]{1,7})/i);
        if (match && match[1].length < 7) {
          homeroom = match[1];
          console.log("Found homeroom after label:", homeroom);
          break;
        }
        
        // Or value before "home room"
        const matchBefore = line.match(/([a-zA-Z0-9]{1,7})[^a-zA-Z0-9]{0,10}home\s*room/i);
        if (matchBefore && matchBefore[1].length < 7) {
          homeroom = matchBefore[1];
          console.log("Found homeroom before label:", homeroom);
          break;
        }
      }
    }

    console.log("Final homeroom extraction:", homeroom || "");

  // Log extraction for debugging
  console.log("Extracted student info:", {
    parentemail,
    parentphonenumber,
    password,
    gender,
    name,
     homeroom: homeroom || "" 
  });

    return { parentemail, parentphonenumber, password, gender, name, homeroom : homeroom || ""  };
  }

  // ...existing code...
  const handleFileChange = async (event) => {


    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      const fileURL = URL.createObjectURL(file);
      setPdfFileUrl(fileURL);

      try {
        const pdf = await pdfjsLib.getDocument(fileURL).promise;
        const numPages = pdf.numPages;
        const extracted = {};

        for (let i = 1; i <= numPages; i++) {
          const page = await pdf.getPage(i);
          const textContent = await page.getTextContent();
          const pageText = textContent.items.map((item) => item.str).join(' ');
          extracted[`Page ${i}`] = pageText;
        }

        console.log('Extracted PDF Text (raw pages):', extracted);

        // For each page, extract the 5 fields
        const studentsArray = Object.keys(extracted).map((pageKey, idx) => {
          const pageText = extracted[pageKey] || "";
          const info = extractStudentInfo(pageText);
          return {
            page: idx + 1,
            pageKey,
            rawText: pageText,
            ...info
          };
        });

        console.log('Parsed students array:', studentsArray);
        setPdfText(studentsArray);

        // Run matching and updating right after parsing
        if (Array.isArray(astheycome) && Array.isArray(studentsArray)) {
          console.log(`🎯 Calling matchAndUpdateStudents with activeid=${activeid}`);
          const result = await matchAndUpdateStudents(astheycome, studentsArray, firebase, activeid);
          alert(`${result.updatedCount} out of ${astheycome.length} students were found and updated.`);
        }

      } catch (err) {
        console.error('Error extracting PDF text:', err);
        setPdfText(null);
      }
    } else {
      alert('Please select a valid PDF file.');
      setPdfFileUrl(null);
      setPdfText(null);
    }
  };
  // ...existing code...

  function cleanDigits(s = "") {
    return String(s).replace(/\D/g, "");
  }

  function normalizePhone(raw) {
    if (!raw) return "";
    let digits = cleanDigits(raw);
    // remove leading 1 if present (country code)
    if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
    // only accept exact 10-digit result
    return digits.length === 10 ? digits : "";
  }

  function escapeRegex(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }


  function normalizeGender(raw) {
    if (!raw && raw !== 0) return "undisclosed";
    const s = String(raw).toLowerCase();
    // find first token that is m/male/f/female anywhere in the value
    const m = s.match(/\b(m|male|f|female)\b/i);
    if (m) {
      const token = m[1].toLowerCase();
      if (token === "m" || token === "male") return "male";
      if (token === "f" || token === "female") return "female";
    }
    return "undisclosed";
  }

  // labels map: regex label -> normalized key
  const LABELS = [
    { label: "Home Phone", key: "home_phone" },
    { label: "Father's Home Phone", key: "father_phone" },
    { label: "Mother's Home Phone", key: "mother_phone" },
    { label: "Father's Email", key: "father_email" },
    { label: "Mother's Email", key: "mother_email" },
    { label: "Student Web ID", key: "student_web_id" },
    { label: "Student ID", key: "student_id" },
    { label: "Student number", key: "student_number" },
    { label: "Gender", key: "gender" },
    { label: "Student Password", key: "password" },
    // add more as needed
  ];

  return (
    <div className="inner123">
      {typeof temparray != "undefined" && astheycome == [] ? (
        <>
          {typeof activeid2 != "undefined" ? <div className="centerme2951">Selected Google <br />Classroom Student </div> : <div className="centerme2951">Google Classroom <br />Students</div>}
          {temparray.map((item, index) => (
            <div key={item.id || index}>

              {typeof activeid2 == "undefined" ? (
                <div onClick={() => selectHandler(item, index)}>
                  <div
                    className={item.id == activeid2 ? "passstart2" : "passstart"}
                  >
                    <div onClick={() => console.log("select")}>
                      {item.localfirstname} {item.locallastname} {item.homeroom ? <span style={{ color: "yellow" }}>{item.homeroom}</span> : ""}<br></br>
                      {item.email}-{item.passwordactual}
                    </div>
                    <div></div>
                  </div>
                </div>
              ) : typeof activeid2 != "undefined" &&
                activeid2 != item.id ? null : (
                <div>
                  <div
                    className={item.id == activeid2 ? "passstart2" : "passstart"} onClick={() => selectHandler(item, index)}
                  >
                    <div onClick={() => console.log("select")}>
                      {item.localfirstname} {item.locallastname} {item.homeroom ? <span style={{ color: "yellow" }}>{item.homeroom}</span> : ""}<br></br>
                      {item.email}-{item.passwordactual}
                    </div>
                    <div></div>
                  </div>
                  <br></br>
                </div>
              )}
            </div>
          ))}
        </>
      ) : typeof temparray != "undefined" && astheycome != [] ? (
        <>
          {typeof activeid2 != "undefined" ? <div className="centerme2951">Selected "{activename}" <br />Classroom Student </div> : <>
            <div className="centerme2951">Complete Setup</div>
            <br></br>
            <div className="centerme295120">Go to your Student Information System and download (pdf) the sheets containing parent contact information for the students in this class -then access it with the (Choose File) button below. This will add that information to these student profiles.</div>
  <br></br>
            <button
              onClick={() => setShowVideoModal(true)}
              style={{
                display: "inline-block",
                marginTop: "12px",
                padding: "8px 16px",
                background: "#0a84ff",
                color: "#fff",
                textDecoration: "none",
                border: "none",
                borderRadius: "4px",
                fontSize: "14px",
                cursor: "pointer"
              }}
            >
              📺 Watch Tutorial Video
            </button>
            <br></br>
              <br></br>

            <div>
              <input type="file" accept=".pdf" onChange={handleFileChange} />
            </div>

            <br></br>


            <div className="centerme2951">All "{activename}"<br />Students</div></>}
          {astheycome.map((item, index) => (
            <div key={item.id || index}>

              {typeof activeid2 == "undefined" ? (
                <div onClick={() => selectHandler(item, index)}>
                  <div
                    className={item.id == activeid2 ? "passstart2" : "passstart"}
                  >
                    <div onClick={() => console.log("select")}>
                      {item.localfirstname} {item.locallastname} {item.homeroom ? <span style={{ color: "yellow" }}>{item.homeroom}</span> : ""}<br></br>
                      {item.email}-{item.passwordactual}
                    </div>
                    <div></div>
                  </div>
                </div>
              ) : typeof activeid2 != "undefined" &&
                activeid2 != item.id ? null : (
                <div>
                  <div
                    className={item.id == activeid2 ? "passstart2" : "passstart"} onClick={() => selectHandler(item, index)}
                  >
                    <div onClick={() => console.log("select")}>
                      {item.localfirstname} {item.locallastname} {item.homeroom ? <span style={{ color: "yellow" }}>{item.homeroom}</span> : ""}<br></br>
                      {item.email}-{item.passwordactual}
                    </div>
                    <div></div>
                  </div>
                  <br></br>
                </div>
              )}
            </div>
          ))}
        </>
      ) : null}
      <br></br>
      
      {/* Video Modal */}
      {showVideoModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "20px",
            maxWidth: "90%",
            maxHeight: "90%",
            position: "relative",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
          }}>
            <button
              onClick={() => setShowVideoModal(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                fontSize: "28px",
                cursor: "pointer",
                color: "#333"
              }}
            >
              ✕
            </button>
            <iframe
              width="800"
              height="450"
              src="https://www.youtube.com/embed/EisG84HVeVY"
              title="Tutorial Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                borderRadius: "4px"
              }}
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}

/* <View>
<div
  style={
    item.id === idselected ? styles.selected : styles.unselected
  }
  onClick={() => selectHandler(item)}>
  <div style={styles.end}>{item.firstname} {item.lastname}{'\n'}{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}{'\n'}{item.comingfrom} -{item.destination} - {item.timeallowedonpass} min.</div>
</div>


</View> */
